import { render, staticRenderFns } from "./CoAdminMembersPlan.vue?vue&type=template&id=568b4186&"
import script from "./CoAdminMembersPlan.vue?vue&type=script&lang=ts&"
export * from "./CoAdminMembersPlan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports